/* eslint-disable no-console */
import {Col, Row} from 'antd';
import React from 'react';

import InformativeText from '../../../../../../constants/InformativeText';
import {convertPxToRem} from '../../../../../../utils/commonFunctions';
import AllFacilityDisplay from '../../../../components/AllFacilityDisplay';
import LabelChart from '../../../../components/LabelChart';
import TotalChartList from '../../../../components/TotalChartList';
import ValueRepresentationBox from '../../../../components/ValueRepresentationBox';
import {rowGutterNZM} from '../../../../constants/commonConstants';
import AllSuppliers from '../../../../supplyChain/utils/AllSuppliers';

const ConsumptionFuel: React.FC<{data: any[]}> = ({data}) => {
  const fuelInfo = InformativeText?.NZM?.utility?.fuel;

  return (
    <>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(466)}}>
        <Col span={8}>
          <LabelChart
            data={data}
            keyArray={[
              'total machine and vehicle consumption',
              'consumption by machine',
              'consumption by vehicle'
            ]}
            chartType="progress"
            customLabel="TOTAL CONSUMPTION"
          />
        </Col>
        <Col span={8}>
          <LabelChart
            data={data}
            keyArray={[
              'total consumption by machine',
              'Total Non-Renewable Stationary Fuel consumption',
              'Total Renewable Stationary Fuel consumption'
            ]}
            chartType="progress"
            customLabel="TOTAL CONSUMPTION"
          />
        </Col>
        <Col span={8}>
          <LabelChart
            data={data}
            keyArray={[
              'total consumption by vehicle',
              'Total Non Renewable Vehicle Fuel consumption',
              'Total Renewable Vehicle Fuel consumption'
            ]}
            chartType="progress"
            customLabel="TOTAL CONSUMPTION"
          />
        </Col>
      </Row>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(499)}}>
        <Col span={20}>
          <TotalChartList
            chartType="line"
            showTotal={false}
            keyArray={['trends over time']}
            data={data}
            dataInMainData={true}
            showChartList={false}
          />
        </Col>
        <Col span={4}>
          <Row gutter={rowGutterNZM} style={{height: convertPxToRem(499)}}>
            <Col span={24}>
              <ValueRepresentationBox
                data={data}
                mainKey="fuel consumption per employee"
                smallImage={true}
              />
            </Col>
            <Col span={24}>
              <ValueRepresentationBox
                data={data}
                mainKey="fuel consumption per unit of production or revenue"
                smallImage={true}
                tooltip={
                  fuelInfo?.Fuel_Consumption_per_Unit_of_Production_or_Revenue
                }
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(792)}}>
        <Col span={12}>
          <AllSuppliers
            data={data}
            keyArray={['consumption by vehicle type and fuel type']}
            type="fuelUtility"
            customTitle="TOTAL NO. OF VEHICLE TYPE"
          />
        </Col>
        <Col span={12}>
          <AllFacilityDisplay
            data={data}
            keyArray={['consumption by facility']}
            type="fuelUtility"
            showFilter={false}
            isSingle={true}
            customTitle="TOTAL NO. OF FACILITY"
          />
        </Col>
      </Row>
    </>
  );
};

export default ConsumptionFuel;
